import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { reducer as toastr } from 'react-redux-toastr';
import { localeReducer } from 'react-localize-redux';

import authReducer from './modules/auth';
import accountsReducer from './modules/accounts';
import packetboxesReducer from './modules/packetboxes';
import endUserKeysReducer from './modules/endUserKeys';
import endUserReducer from './modules/endUsers';
import messagesReducer from './modules/messages';
import eventsReducer from './modules/events';
import loraConfigsReducer from './modules/loraConfigs';
import alertReduces from './modules/alerts';
import alertTypesReduces from './modules/alertTypes';
import notifyCenter from './modules/notifyCenter';

export default combineReducers({
  form,
  toastr,
  auth: authReducer,
  accounts: accountsReducer,
  packetboxes: packetboxesReducer,
  endUserKeys: endUserKeysReducer,
  endUsers: endUserReducer,
  loraConfigs: loraConfigsReducer,
  events: eventsReducer,
  messages: messagesReducer,
  alerts: alertReduces,
  alertTypes: alertTypesReduces,
  notifyCenter,
  locale: localeReducer,
});



// WEBPACK FOOTER //
// ./src/redux/combined.js